export default __webpack_public_path__ + "static/media/book1.008d6ee3.png";